import React, { FC } from 'react';
import ImportGridModal from './ImportGridModal';

interface OWFlatfileImporterProps {
	dataLoadComplete: boolean;
	entityName?: string;
	type: string;
	fields: any[];
	data: Record<string, any>[];
	onComplete?: () => void;
	onDataLoad: (result: { validData: any[] }) => Promise<any>;
	recordHook?: (record: any) => any;
	validateRecordsOnSubmit?: (data: any[]) => string | undefined | null | false;
}

// Parent owns the open state via `dataLoadComplete` and is expected to flip it
// back to false from its `onComplete` handler. Visibility is derived directly
// from the prop — no local state — so the modal renders correctly on first
// paint when `dataLoadComplete` arrives true.
const OWFlatfileImporter: FC<OWFlatfileImporterProps> = ({
	dataLoadComplete,
	entityName,
	type,
	fields,
	data,
	onComplete,
	onDataLoad,
	recordHook,
	validateRecordsOnSubmit,
}) => {
	if (!dataLoadComplete) return null;

	const handleClose = () => {
		if (onComplete) onComplete();
	};

	return (
		<ImportGridModal
			visible
			title={`Edit ${entityName || type}`}
			fields={fields}
			initialData={data}
			skipUpload
			recordHook={recordHook}
			validateRecordsOnSubmit={validateRecordsOnSubmit}
			onDataLoad={onDataLoad}
			onCancel={handleClose}
			onComplete={handleClose}
		/>
	);
};

export default OWFlatfileImporter;
